module.exports = __webpack_public_path__ + "img/frame2.8f277cba.png";